import React from "react";
import ExtraSmallFilledButton from "../../common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../hooks/useLocales";

//  Are you sure you want to Logout?
//         a confirmation modal will be shown when user clicks on logout button.

const LogoutConfirmModal = ({ isOpen, onCancel, onConfirm }) => {
  const { translate } = useLocales();
  if (!isOpen) return null;
  return (
    <div
      style={{ zIndex: "999999999999" }}
      className="fixed inset-0 h-screen w-screen flex items-center justify-center"
    >
      <div
        style={{ zIndex: "999999" }}
        className="absolute h-screen w-screen inset-0 bg-gray-800 opacity-50"
      ></div>
      <div
        style={{ zIndex: "9999999" }}
        className="bg-white dark:bg-dark-secondary rounded-lg p-6 "
      >
        <p className="text-body_copy1 mb-4 dark:text-color_v1_dark">
          {translate("cms.you_sure_want_to_logout")}
        </p>
        <div className="flex items-center justify-end">
          <button
            className="text-small2_b dark:text-color_v1_dark gray-700"
            onClick={onCancel}
          >
            {translate("cms.cancel")}
          </button>

          <ExtraSmallFilledButton
            name={translate("header.logout")}
            buttonType={"button"}
            onClickHandler={onConfirm}
            classes={"ms-3"}
          />
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmModal;
